import { AppColors } from "@/styles/colors";
import { SelectComponent } from "@/components/select/Select";
import { Button, Flex, Text } from "@chakra-ui/react";
import { FieldValues, useForm, useWatch } from "react-hook-form";

interface Props {
  items: { label: string; value: string }[];
  loading?: boolean;
  saving?: boolean;
  onSave?: (idDeposito: number) => Promise<void>;
}

export const DepositoSelector = ({ items, loading, saving, onSave }: Props) => {
  const { control, handleSubmit } = useForm<FieldValues>({
    defaultValues: { idDeposito: [] },
  });
  const idDeposito = useWatch({ control, name: "idDeposito" });

  const submit = handleSubmit(async (values) => {
    const selected = Number(values?.idDeposito?.[0]);
    if (!Number.isFinite(selected) || selected <= 0) return;
    await onSave?.(selected);
  });

  return (
    <Flex alignItems="center" gap="8px" flexWrap="wrap">
      <SelectComponent
        name="idDeposito"
        control={control}
        placeholder="Seleccionar"
        items={items}
        loading={loading}
        disabled={loading || saving}
        minHeight="32px"
        size="xs"
      />
      <Button
        height="28px"
        paddingX="10px"
        bgColor={AppColors.GREEN_PRIMARY}
        onClick={submit}
        loading={saving}
        disabled={saving || loading || !idDeposito?.length}
      >
        <Text fontWeight={600} fontSize="12px">
          Guardar
        </Text>
      </Button>
    </Flex>
  );
};
